import {
  AirConditioning,
  Blinds,
  Electricians,
  KitchenRenovations,
  LandscapeRenovations,
  LawnMowingServices,
  MedicalCentre,
  PestControl,
  Physiotherapy,
  Restaurants,
  Solicitors,
  Tyres,
  Florists,
  Carpet,
  Roofing,
  Removalist,
  Locksmith,
  Cafes,
  Plumbers,
  Hairdressers,
  Pubs,
  Mechanics,
  Massage,
  Auto,
} from '../../assets/popularCategories';

const POPULAR_CATEGORIES = [
  { name: 'Plumbers', image: Plumbers, urlSlug: 'canberra-act' },
  { name: 'Hairdressers', image: Hairdressers, urlSlug: 'central-coast-nsw' },
  { name: 'Pubs & Taverns', image: Pubs, urlSlug: 'gold-coast-qld' },
  { name: 'Mechanics', image: Mechanics, urlSlug: 'townsville-qld' },
  { name: 'Massage Therapists', image: Massage, urlSlug: 'cairns-qld' },
  { name: 'Auto Wreckers', image: Auto, urlSlug: 'sunshine-coast-qld' },
  {
    name: 'Air Conditioning',
    image: AirConditioning,
    urlSlug: 'rockhampton-qld',
  },
  { name: 'Blinds', image: Blinds, urlSlug: 'townsville-qld' },
  { name: 'Electricians', image: Electricians, urlSlug: 'mackay-qld' },
  {
    name: 'Kitchen Renovations & Installations',
    image: KitchenRenovations,
    urlSlug: 'ballina-nsw-2478',
  },
  {
    name: 'Lawn Mowing Services',
    image: LandscapeRenovations,
    urlSlug: 'port-macquarie-nsw',
  },
  {
    name: 'Landscape Supplies',
    image: LawnMowingServices,
    urlSlug: 'gympie-qld',
  },
  {
    name: 'Medical Centres',
    category: 'Doctors & Medical Centres',
    image: MedicalCentre,
    urlSlug: 'darwin-nt',
  },
  { name: 'Pest Control', image: PestControl, urlSlug: 'bundaberg-qld' },
  {
    name: 'Physiotherapy',
    category: 'Physiotherapists',
    image: Physiotherapy,
    urlSlug: 'newcastle-nsw',
  },
  { name: 'Restaurants', image: Restaurants, urlSlug: 'coffs-harbour-nsw' },
  {
    name: 'Lawyers',
    image: Solicitors,
    urlSlug: 'lismore-nsw-2480',
  },
  { name: 'Tyres', image: Tyres, urlSlug: 'wodonga-vic' },
  {
    name: 'Roofing Construction',
    category: 'Roofing Contractors',
    image: Roofing,
    urlSlug: 'taree-nsw',
  },
  {
    name: 'Carpet Cleaning',
    image: Carpet,
    urlSlug: 'hervey-bay-qld',
  },
  {
    name: 'Cafes',
    category: 'Cafes & Coffee Shops',
    image: Cafes,
    urlSlug: 'fraser-coast-qld',
  },
  {
    name: 'Florists',
    category: 'Florists',
    image: Florists,
    urlSlug: 'cardiff-nsw',
  },
  {
    name: 'Removalists',
    category: 'Removalists',
    image: Removalist,
    urlSlug: 'maitland-nsw',
  },
  {
    name: 'Locksmiths',
    image: Locksmith,
    urlSlug: 'burleigh-heads-qld',
  },
];

export default POPULAR_CATEGORIES;
